// EN translations for company tags/suggestions.
// Backend stores German originals; frontend displays EN when language is 'en'.
// Tags already in English map to themselves. Custom tags fall back to original.

export const CEVEE_TAGS_EN: Record<string, string> = {
  'Klein aber fein': 'Small but mighty',
  'Chaos aber nice': 'Chaos but nice',
  'Old but gold': 'Old but gold',
  'Move fast': 'Move fast',
  'Hidden champion': 'Hidden champion',
  'Family vibes': 'Family vibes',
  'Design-driven': 'Design-driven',
  'Impact-first': 'Impact-first',
  'Voll remote': 'Fully remote',
  'Grown-up Startup': 'Grown-up Startup',
  'Underdog energy': 'Underdog energy',
  'Corporate mit Herz': 'Corporate with heart',
  'Gründer:innen-DNA': 'Founder DNA',
  'Chill but ambitious': 'Chill but ambitious',
  'Culture > Perks': 'Culture > Perks',
  'Purpose-driven': 'Purpose-driven',
  'Hands-on Mentalität': 'Hands-on mentality',
  'Teamplayer-Kultur': 'Teamplayer culture',
  'Tradition trifft Innovation': 'Tradition meets innovation',
  'Nahbar & echt': 'Approachable & authentic',
  'Wir statt Ich': 'We over me',
  'Macher:innen-DNA': 'Doer DNA',
  'Lokal verwurzelt': 'Locally rooted',
  'Built different': 'Built different',
  'Nerd paradise': 'Nerd paradise',
  'Rocket ship 🚀': 'Rocket ship 🚀',
  'Bootstrapped': 'Bootstrapped',
  'Deep Tech': 'Deep Tech',
  'No Bullshit': 'No Bullshit',
  'Real Talk Kultur': 'Real Talk culture',
  'Lernort statt Karriereleiter': 'Learning over ladder-climbing',
  'Ausbildung mit Herz': 'Training with heart',
  'Meister:innen gesucht': 'Master craftspeople wanted',
  'Remote-first': 'Remote-first',
  'Flat Hierarchy': 'Flat Hierarchy',
  'Diverse & Inclusive': 'Diverse & Inclusive',
  'Work-Life Balance': 'Work-Life Balance',
  '4-Tage-Woche': '4-day week',
  'Dog-friendly': 'Dog-friendly',
  'Learning Culture': 'Learning Culture',
  'Team Events': 'Team Events',
  'Flexible Hours': 'Flexible Hours',
  'Teilzeit möglich': 'Part-time possible',
  'Mentorship': 'Mentorship',
  'Nachhaltigkeit': 'Sustainability',
  'Creative Freedom': 'Creative Freedom',
  'International': 'International',
  'Mental Health matters': 'Mental Health matters',
  'Ausbildung willkommen': 'Apprentices welcome',
  'Quereinstieg möglich': 'Career changers welcome',
  'Duzen statt Siezen': 'First-name basis',
  'Non-Profit': 'Non-Profit',
  'Social Impact': 'Social Impact',
  'Ehrenamt meets Job': 'Volunteering meets work',
  'Gemeinnützig': 'Charitable',
  'Klima-First': 'Climate-first',
  'Female founded': 'Female founded',
  'Migrant-friendly': 'Migrant-friendly',
  'Werkstudent:innen welcome': 'Working students welcome',
  'Side Hustle ok': 'Side Hustle ok',
  'Safe Space': 'Safe Space',
  'LGBTQ+ friendly': 'LGBTQ+ friendly',
  'Barrierefrei': 'Barrier-free',
  // Startup & Growth
  'VC-backed': 'VC-backed',
  'Pre-Seed': 'Pre-Seed',
  'Seed Stage': 'Seed Stage',
  'Series A': 'Series A',
  'Hyper Growth': 'Hyper Growth',
  'Global ambition': 'Global ambition',
  '0 to 1': '0 to 1',
  'Product-led': 'Product-led',
  'Founding team': 'Founding team',
  'Equity for all': 'Equity for all',
  'Fail fast, learn faster': 'Fail fast, learn faster',
  'Ship it': 'Ship it',
  'Day 1 mentality': 'Day 1 mentality',
  'Builder culture': 'Builder culture',
  'Ownership': 'Ownership',
  'Wear many hats': 'Wear many hats',
  'Serial entrepreneur': 'Serial entrepreneur',
  'Experienced team': 'Experienced team',
  'First 10 hires': 'First 10 hires',
  'Exit-erfahren': 'Exit-experienced',
  // Work Style (new)
  'Async-first': 'Async-first',
  'No Meetings Day': 'No Meetings Day',
  'Workation': 'Workation',
  'Home Office Budget': 'Home Office Budget',
  'Offsites': 'Offsites',
  'Unlimited PTO': 'Unlimited PTO',
  'Sabbatical möglich': 'Sabbatical possible',
  'Bomb Benefits': 'Bomb Benefits',
  'Transparente Gehälter': 'Transparent salaries',
  'Open Door Policy': 'Open Door Policy',
  // Industry-specific vibes
  'B2B SaaS': 'B2B SaaS',
  'B2C': 'B2C',
  'Developer Tools': 'Developer Tools',
  'FinTech': 'FinTech',
  'HealthTech': 'HealthTech',
  'EdTech': 'EdTech',
  'CleanTech': 'CleanTech',
  'PropTech': 'PropTech',
  'FoodTech': 'FoodTech',
  'LegalTech': 'LegalTech',
  'Mittelstand 2.0': 'Mittelstand 2.0',
  'Familienunternehmen': 'Family business',
  'Agenturleben': 'Agency life',
  'Klinik & Praxis': 'Clinic & practice',
  'Handwerk mit Zukunft': 'Future-proof trades',
};

export const INDUSTRY_EN: Record<string, string> = {
  // Tech
  'Technologie': 'Technology',
  'IT': 'IT',
  'SaaS': 'SaaS',
  'Software': 'Software',
  'AI': 'AI',
  'Machine Learning': 'Machine Learning',
  'Gaming': 'Gaming',
  'Entertainment': 'Entertainment',
  'Telekommunikation': 'Telecommunications',
  // Business & Services
  'Startup': 'Startup',
  'Beratung': 'Advisory',
  'Consulting': 'Consulting',
  'Agentur': 'Agency',
  'Marketing': 'Marketing',
  'Personaldienstleistung': 'Staffing & Recruitment',
  // Health
  'Gesundheit': 'Healthcare',
  'Pharma': 'Pharma',
  'Chemie': 'Chemicals',
  // Finance & Legal
  'Finanzen': 'Finance',
  'Banking': 'Banking',
  'Versicherung': 'Insurance',
  'Recht': 'Legal',
  'Steuern': 'Tax',
  // Education & Research
  'Bildung': 'Education',
  'Forschung': 'Research',
  // Commerce
  'E-Commerce': 'E-Commerce',
  'Handel': 'Retail',
  'Mode': 'Fashion',
  'Beauty': 'Beauty',
  'Friseur': 'Hair',
  'Kosmetik': 'Cosmetics',
  // Energy & Sustainability
  'Energie': 'Energy',
  'Nachhaltigkeit': 'Sustainability',
  // Media & Culture
  'Medien': 'Media',
  'Kreativ': 'Creative',
  'Kultur': 'Culture',
  'Events': 'Events',
  // Trades & Industry
  'Handwerk': 'Skilled trades',
  'Maschinenbau': 'Mechanical Engineering',
  'Industrie': 'Manufacturing',
  'Automobilindustrie': 'Automotive',
  'Luftfahrt': 'Aerospace',
  'Raumfahrt': 'Aerospace (Space)',
  // Logistics & Transport
  'Logistik': 'Logistics',
  'Transport': 'Transport',
  // Real Estate & Construction
  'Immobilien': 'Real Estate',
  'Bau': 'Construction',
  // Hospitality & Food
  'Gastronomie': 'Gastronomy',
  'Hotellerie': 'Hospitality',
  'Landwirtschaft': 'Agriculture',
  'Lebensmittel': 'Food',
  // Non-Profit & Public
  'Non-Profit': 'Non-Profit',
  'NGO': 'NGO',
  'Öffentlicher Dienst': 'Public sector',
  'Soziale Arbeit': 'Social work',
  // Sports
  'Sport': 'Sports',
  'Fitness': 'Fitness',
};

export const LOCATION_EN: Record<string, string> = {
  'Deutschland': 'Germany',
  'Österreich': 'Austria',
  'Schweiz': 'Switzerland',
  'Europa': 'Europe',
  'Weltweit': 'Worldwide',
  'Genf': 'Geneva',
  'Norddeutschland': 'Northern Germany',
  'Süddeutschland': 'Southern Germany',
  'Ostdeutschland': 'Eastern Germany',
  'Westdeutschland': 'Western Germany',
  'Rheinland': 'Rhineland',
  'Franken': 'Franconia',
  'Schwaben': 'Swabia',
  'Ruhrgebiet': 'Ruhr Area',
  'Rhein-Main': 'Rhine-Main',
  'Rhein-Neckar': 'Rhine-Neckar',
  'Rhein-Ruhr': 'Rhine-Ruhr',
  'Uni-Stadt': 'University town',
  'Großstadt': 'Major city',
  'Mittelstadt': 'Mid-size city',
  'Metropolregion': 'Metropolitan area',
  'Pendlerfreundlich': 'Commuter-friendly',
  'Vor Ort / On-site': 'On-site',
  'Fahrradfreundlich': 'Bike-friendly',
  'Gute ÖPNV-Anbindung': 'Good public transport',
  'Bezahlbar': 'Affordable',
  'Viel Natur / Grüne Stadt': 'Green city / Lots of nature',
  'Internationale Community': 'International community',
  'Berge & Natur': 'Mountains & nature',
  'Kulturszene': 'Cultural scene',
  'Nah am Wasser': 'Near the water',
  'Ländlich / Kleinstadt': 'Rural / Small town',
  'Küstennähe': 'Near the coast',
  'Alpenregion': 'Alpine region',
  'Bayern': 'Bavaria',
  'Niedersachsen': 'Lower Saxony',
  'Sachsen': 'Saxony',
  'Thüringen': 'Thuringia',
  'Mecklenburg-Vorpommern': 'Mecklenburg-Western Pomerania',
  'Sachsen-Anhalt': 'Saxony-Anhalt',
};

export const LOOKING_FOR_EN: Record<string, string> = {
  'Projektmanager:in': 'Project Manager',
  'Berater:in': 'Consultant',
  'Buchhalter:in': 'Accountant',
  'Einkauf': 'Procurement',
  'Logistik': 'Logistics',
  'Lagerist:in': 'Warehouse Worker',
  'Redakteur:in': 'Editor',
  'Texter:in / Copywriter': 'Copywriter',
  'Jurist:in': 'Lawyer',
  'Rechtsanwält:in': 'Attorney',
  'Notar:in': 'Notary',
  'Ärzt:in': 'Doctor / Physician',
  'Medizinische Fachangestellte (MFA)': 'Medical Assistant (MFA)',
  'Zahnarztpraxis': 'Dental Practice',
  'Physiotherapeut:in': 'Physiotherapist',
  'Apotheker:in': 'Pharmacist',
  'Psycholog:in': 'Psychologist',
  'Steuerberater:in': 'Tax Advisor',
  'Wirtschaftsprüfer:in': 'Auditor',
  'Steuerfachangestellte:r': 'Tax Clerk',
  'Architekt:in': 'Architect',
  'Bauingenieur:in': 'Civil Engineer',
  'Bauleiter:in': 'Site Manager',
  'Lehrer:in': 'Teacher',
  'Dozent:in': 'Lecturer',
  'Wissenschaftliche:r Mitarbeiter:in': 'Research Associate',
  'KFZ-Mechatroniker:in': 'Automotive Mechanic',
  'Tischler:in / Schreiner:in': 'Carpenter',
  'Maler:in & Lackierer:in': 'Painter',
  'SHK (Sanitär/Heizung/Klima)': 'Plumbing / Heating / AC',
  'Dachdecker:in': 'Roofer',
  'Mechatroniker:in': 'Mechatronics Technician',
  'Versicherungskaufmann/-frau': 'Insurance Agent',
  'Immobilienmakler:in': 'Real Estate Agent',
  'Fahrer:in / LKW': 'Truck Driver',
  'Kurier / Lieferdienst': 'Courier / Delivery',
  'Werkstudent:innen': 'Working Students',
  'Praktikum': 'Internships',
  'Azubis': 'Apprentices',
  'Ausbildung': 'Vocational Training',
  'Handwerk': 'Skilled Trades',
  'Technik': 'Technical',
  'Pflege': 'Care',
  'Soziales': 'Social Work',
  'Ingenieurwesen': 'Engineering',
  'Recht': 'Legal',
  'Compliance': 'Compliance',
  'Assistenz': 'Assistant',
  'Office': 'Office & Admin',
  'Einzelhandel': 'Retail',
  'Verkauf': 'Sales',
  'Koch': 'Chef',
  'Küche': 'Kitchen',
  'Elektriker:in': 'Electrician',
  'Sanitär': 'Plumbing',
  'Friseur:in': 'Hairdresser',
  'Stylist:in': 'Stylist',
  'Erzieher:in': 'Educator',
  'Pädagogik': 'Pedagogy',
};

type TranslationMap = Record<string, string>;

export function translateTag(tag: string, language: string, map: TranslationMap): string {
  if (language === 'en' && map[tag]) return map[tag];
  return tag;
}
